import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AppConstantsService {
    private readonly STORAGE_KEY = 'APP_CONSTANTS';

    // Declare properties directly on the class
    USER_NAME!: string;
    CONTEXT!: string | null;
    COURT!: string | null;
    INITIAL_DOCUMENT_ID!: string | null;
    INITIAL_DOCUMENT_MSG!: string | null;
    DIVISION_ID!: number;
    DIVISION_NAME!: string | null;
    COURT_STAFF_CODE!: string | null;
    COURT_CASE_LABEL!: string;
    COURT_TYPE!: string;
    STAFF_TYPE!: string;
    COURT_LEVEL!: number;
    USER_ROLE_NAME!: string;
    STAFF_NAME!: string | null;
    JUDICIAL_STAFF_TYPE!: string | null;
    SESSION_TIMEOUT!: number | null;
    WARNING_BEFORE_SESSION_TIMEOUT!: number | null;
    MENU_LIST!: any[] | null;
    SC_COURT_TYPE!: string;
    COA_COURT_TYPE!: string;
    HC_COURT_TYPE!: string;
    SC_COURT_LEVEL_ID!: number;
    COA_COURT_LEVEL_ID!: number;
    HC_COURT_LEVEL_ID!: number;
    COURT_ID_CASE_LABEL!: string;
    HEARING_LABEL!: string;
    JUDGE_LABEL!: string;
    COURT_ROOM_LABEL!: string;
    FIRST_PARTY_LABEL!: string;
    SECOND_PARTY_LABEL!: string;
    FILED_BY_LABEL!: string;
    ALERT_MESSAGE_FOR_USER_SAVE!: string;
    ALERT_MESSAGE_FOR_USER_MODIFY!: string;
    ALERT_MESSAGE_FOR_USER_DELETE!: string;
    ALERT_MESSAGE_FOR_USER_SELECTION_NO_DELETE!: string;
    FI_FIRST_PARTY_LABEL!: string;
    FI_SECOND_PARTY_LABEL!: string;
    APPEAL_FIRST_PARTY_LABEL!: string;
    APPEAL_SECOND_PARTY_LABEL!: string;
    DTP_RESPONDENT_BRIEF!: string;
    DTP_APPELLANT_BRIEF!: string;
    MSG_NO_BRIEFS_RECORDED!: string;
    AWAITING_FOR_OATH!: string;
    FIXED_FOR_OATH_PHASE_TYPE!: string;
    AWAITING_FOR_HEARING_TRAIL_COURT_PHASE_TYPE!: string;
    FIXED_FOR_HEARING_TRAIL_COURT_PHASE_TYPE!: string;
    MOTION_AWAITING_FOR_HEARING_PHASE_TYPE!: string;
    MOTION_FIXED_FOR_HEARING_PHASE_TYPE!: string;
    AWAITING_FOR_HEARING_PHASE_TYPE!: string;
    FIXED_FOR_HEARING_PHASE_TYPE!: string;
    COURT_ROOM_TO_BE_ASSIGNED_PHASE_TYPE!: string;
    COURT_ROOM_ASSIGNED_PHASE_TYPE!: string;
    ALL_CONSTANT!: string;
    CASE_CATEGORY_FIRST_INSTANCE!: string;
    CASE_CATEGORY_FIRST_INSTANCE_SHORT_NAME!: string;
    CASE_CATEGORY_APPEAL!: string;
    CASE_CATEGORY_APPEAL_SHORT_NAME!: string;
    CASE_CATEGORY_ALL!: string;
    CASE_CATEGORY_ALL_SHORT_NAME!: string;
    CAUSELIST_DATEVALUE_DATERANGE!: string;
    CAUSELIST_DATEVALUE_DAILY!: string;
    HC_DTP_FINAL_ADDRESS!: string;
    INVALID_SEARCH_DATA!: string;
    INVALID_SEARCH_COMMENTS_DATA!: string;
    SC_COURT_NAME!: string;
    COA_COURT_NAME!: string;
    DOC_NOTICE_OF_APPEAL!: string;
    CASE_PHASE_NOTICE_OF_APPEAL_RECEIVED!: string;
    DOC_RECORD_OF_APPEAL!: string;
    CASE_PHASE_RECORD_OF_APPEAL_RECEIVED!: string;
    CHIEF_JUDGE_ROLE_CONSTANT!: string;
    DEPUTY_CHIEF_REGISTRAR_ROLE_CONSTANT!: string;
    ASSISTANT_CHIEF_REGISTRAR_ROLE_CONSTANT!: string;
    HEAD_LITIGATION_ROLE_CONSTANT!: string;
    PRESIDENT_ROLE_CONSTANT!: string;
    PRESIDING_JUDGE_ROLE_CONSTANT!: string;
    ROLE_LEVEL_CHIEF_JUDGE_JUSTICE_PRESIDENT!: number;
    PANEL_CATEGORY_NAME_GENERAL!: string;
    PANEL_CATEGORY_NAME_FULL_PANEL!: string;
    PANEL_CATEGORY_NAME_FULL_COURT_PANEL!: string;
    PANEL_CATEGORY_ID_GENERAL!: number;
    PANEL_CATEGORY_ID_FULL_PANEL!: number;
    PANEL_CATEGORY_ID_FULL_COURT_PANEL!: number;
    CASE_TYPE_CR_SHORT_NAME!: string;
    MAX_STAFF_ID!: number;
    MAX_STAFF_ID_ZERO_PADDING!: number;
    CONFIRM_COURT_CHANGE_CASE_RE_ASSIGN_MESSAGE!: string;
    APPEAL_LABEL!: string;
    CASE_LABEL!: string;
    CASE_APPEAL_LABEL!: string;
    CASES_APPEALS_LABEL!: string;
    UNKNOWN_ID_TYPE!: string;

    constructor() {
        this.hydrateFromStorage();
    }

    /**
     * Transforms incoming backend camelCase object to UPPER_SNAKE_CASE
     * and assigns every property directly to `this` instance.
     */
    setConstants(rawBackendData: Record<string, any>): void {
        const formatted = this.transformKeys(rawBackendData);
        sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(formatted));
        Object.assign(this, formatted);
    }

    /** Clears cached values on logout */
    clear(): void {
        sessionStorage.removeItem(this.STORAGE_KEY);
    }

    private hydrateFromStorage(): void {
        const data = sessionStorage.getItem(this.STORAGE_KEY);
        if (data) {
            try {
                Object.assign(this, JSON.parse(data));
            } catch (e) {
                console.error('Failed to parse cached constants', e);
            }
        }
    }

    private transformKeys(obj: Record<string, any>): Record<string, any> {
        const result: Record<string, any> = {};
        for (const key of Object.keys(obj)) {
            const upperKey = key.replace(/([a-z0-9])([A-Z])/g, '$1_$2').toUpperCase();
            result[upperKey] = obj[key];
        }
        return result;
    }
}